import { Directive, ElementRef, Renderer2, Input, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';

@Directive({
  selector: '[dsdExtLinkDownloadFileName]',
  standalone: false
})
export class LinkDownloadFileNameDirective implements AfterViewInit {
  @Input('dsdExtLinkDownloadFileName')
  fileName: string;

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private datePipe: DatePipe) {}

  ngAfterViewInit() {
    //Besoin du timeout pour attendre la creation du href dynamique
    setTimeout(() => {
      const anchorElement = this.elementRef.nativeElement.querySelector('a');
      if (anchorElement) {
        const fileName = this.getFileName();
        this.renderer.setAttribute(anchorElement, 'download', fileName);
      }
    }, 250);
  }

  private getFileName(): string {
    const date = new Date();
    const dateFormatee = this.datePipe.transform(date, 'yyyyMMdd');
    return this.fileName + dateFormatee;
  }
}
